export default {
  title: 'Activați rezervările',
  buttons: {
    cancel: 'Anulează',
    activate: 'Activați rezervările',
  },
};
